import React, {useState, useEffect} from 'react';
import './login.scss';
import Logo from 'assets/images/logo.png';

import {useDispatch} from 'react-redux';
import {loginAction} from 'store/action-creators/login';
import {useNavigate} from 'react-router-dom';
import {getAccessToken, setAccessToken, setUserInfoInStorage, useQuery} from 'utils/common';
import LoginForm from 'components/login/LoginForm';
import ForgotForm from 'components/login/ForgotForm';

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const query = useQuery();
  const shouldResetPassword = query.get('reset');

  const [checked, setCheck] = useState(false);

  useEffect(() => {
    if (getAccessToken()) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const loginFormSubmitHandler = async (values, setErrors, setSubmitting) => {
    const response = await dispatch(loginAction(values, setErrors, setSubmitting));

    if (response.status_code === 200) {
      setAccessToken(response.access_token);
      setUserInfoInStorage(response.result);
      navigate('/dashboard');
    }
  };

  const handleCheckChange = () => {
    setCheck(!checked);
  };

  return (
    <div className="Login-main">
      <div className="logo-otr">
        <img className="logo" src={Logo} alt="logo" />
      </div>
      <div className="col-login-otr">
        <div className="col-login-inr">
          {shouldResetPassword ? (
            <ForgotForm />
          ) : (
            <LoginForm
              checked={checked}
              handleCheckChange={handleCheckChange}
              formSubmitHandler={loginFormSubmitHandler}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
